import { defineStore } from 'pinia';

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    isDarkMode: false
  }),
  
  actions: {
    initTheme() {
      if (process.client) {
        // Sayfaya dark class'ını uygula
        if (this.isDarkMode) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      }
    },
    
    toggleDarkMode() {
      if (process.client) {
        document.documentElement.classList.toggle('dark');
        this.isDarkMode = !this.isDarkMode;
      }
    }
  },
  
  persist: {
    storage: process.client ? localStorage : null,
    paths: ['isDarkMode']
  }
});
